import script from "./MyBowlerInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./MyBowlerInfo.vue?vue&type=script&setup=true&lang=js"

import "./MyBowlerInfo.vue?vue&type=style&index=0&id=7a01feb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a01feb8"]])

export default __exports__